import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home/Index";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import Gallery from "./pages/gallery/Gallery";
import Contact from "./pages/contact/Contact";
import Blog from "./pages/blog/Blog";
import ScrollToTop from "./utility/ScrollToTop";
import BlogDescription from "./pages/blog/BlogDescription";

function App() {
  const [filterImg, setFilterImg] = useState<string>("Backdrop Options"); //For filter Gallery Images
  const [galleryHead, setgalleryHead] = useState<string>("Adult Celebration"); //For Set Gallery Category Heading
  return (
    <div className="App">
      {/* <Header setFilterImg={setFilterImg}/>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="gallery" element={<Gallery filterImg={filterImg}/>} />
        </Routes>
      </BrowserRouter>
      <Footer /> */}

      <BrowserRouter>
        <ScrollToTop />
        <Header setFilterImg={setFilterImg} setgalleryHead={setgalleryHead} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDescription />} />
          <Route
            path="/gallery"
            element={
              <Gallery filterImg={filterImg} galleryHead={galleryHead} />
            }
          />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
